import {
  HelpdeskHomeScreen,
  isHelpdeskHomeScreen,
  normalizeHelpdeskHomeScreen,
} from '../utils/helpdeskHomeScreen';

const PERSONAL_KEY_PREFIX = 'know.helpdesk.personalHomeScreen';
const ADMIN_CACHE_KEY = 'know.helpdesk.adminDefaultHomeScreen';

const personalKey = (userId: string): string => `${PERSONAL_KEY_PREFIX}.${userId}`;

export const readPersonalHelpdeskHomeScreen = (userId?: string | null): HelpdeskHomeScreen | null => {
  if (!userId)
  {
    return null;
  }

  try
  {
    const stored = localStorage.getItem(personalKey(userId));
    if (isHelpdeskHomeScreen(stored))
    {
      return stored;
    }
  }
  catch
  {
    // ignore storage errors
  }

  return null;
};

export const writePersonalHelpdeskHomeScreen = (
  userId: string,
  screen: HelpdeskHomeScreen | null,
): void => {
  try
  {
    if (screen === null)
    {
      localStorage.removeItem(personalKey(userId));
      return;
    }

    localStorage.setItem(personalKey(userId), screen);
  }
  catch
  {
    // ignore storage errors
  }
};

export const readCachedAdminHelpdeskHomeScreen = (): HelpdeskHomeScreen | null => {
  try
  {
    const stored = localStorage.getItem(ADMIN_CACHE_KEY);
    if (isHelpdeskHomeScreen(stored))
    {
      return stored;
    }
  }
  catch
  {
    // ignore storage errors
  }

  return null;
};

export const cacheAdminHelpdeskHomeScreen = (screen: unknown): HelpdeskHomeScreen => {
  const normalized = normalizeHelpdeskHomeScreen(screen);

  try
  {
    localStorage.setItem(ADMIN_CACHE_KEY, normalized);
  }
  catch
  {
    // ignore storage errors
  }

  return normalized;
};
